import {
    addQuoteDetails,
    addTestGeometry,
    createQuote,
    deleteQuote,
    getJobFromQuote,
    getQuote,
    getQuoteLineItems,
    getQuoteList,
    getQuoteListForUser,
    replaceLineItemCategoryList,
    updateQuote,
    updateQuoteStatus
} from "../../../api/quote";
import { useMutation, useMutationWithoutResponse, useQuery } from "./helper";
import { useMutation as useReactMutation } from "@tanstack/react-query";
import { TResponseItemWrapper, TResponseListWrapper} from "../../types/common";
import { TQuoteDetails, TQuote, TQuoteLineItems } from "../../types/quote";

export const useQuoteList = (params, options) => useQuery<TResponseListWrapper<TQuote>>({
    queryKey: ['quotes', params],
    queryFn: () => getQuoteList(params),
    ...options
});

export const useQuoteListForUser = (params, options) => useQuery<TResponseListWrapper<TQuote>>({
    queryKey: ['quotes', params],
    queryFn: () => getQuoteListForUser(params),
    ...options
});

export const useQuote = (quoteId, options) => useQuery<TResponseItemWrapper<TQuoteDetails>>({
    queryKey: ['quote', quoteId],
    queryFn: () => getQuote(quoteId),
    ...options,
});

export const useQuoteLineItems = (quoteId, options) => useQuery<TResponseItemWrapper<TQuoteLineItems>>({
    queryKey: ['quote-line-items', quoteId],
    queryFn: () => getQuoteLineItems(quoteId),
    ...options,
});

export const useJobFromQuote = (quoteId, options) => useQuery({
    queryKey: ['quote', quoteId],
    queryFn: () => getJobFromQuote(quoteId),
    ...options,
});

export const useQuoteStatusUpdate = () => useMutation({
    mutationFn: async (payload) => await updateQuoteStatus(payload),
});

export const useQuoteCreate = () => useMutation({
    mutationFn: async (payload) => await createQuote(payload),
});

export const useQuoteAddDetails = () => useMutation({
    mutationFn: async (payload) => await addQuoteDetails(payload),
});

export const useQuoteUpdate = () => useMutation({
    mutationFn: async (payload) => await updateQuote(payload),
});

export const useQuoteDelete = () => useMutation({
    mutationFn: async (quoteId) => await deleteQuote(quoteId),
});

export const useQuoteAddGeometry = () => useReactMutation({
    mutationFn: async (payload: any) => await addTestGeometry(payload),
});

export const useQuoteLineItemsReplace = () => useMutationWithoutResponse({
    mutationFn: async (payload) => await replaceLineItemCategoryList(payload),
});
